import lodash from 'lodash';
import { defaultInstitutionSystemPermissionsSelector } from 'common/permissions/selectors';

export function systemPermissionsSelector(state) {
    let systemPermissions = defaultInstitutionSystemPermissionsSelector(state);
    let permittedSystemPermission = lodash.pickBy(systemPermissions, value => value);
    let arrPermittedSystemPermission = Object.keys(permittedSystemPermission);
    return arrPermittedSystemPermission;
}


